import React, { useEffect, useState } from "react";
import { Handle } from "reactflow";
import "./CustomeNodeData.css";
import {
  fetchAnonProtocols,
  fetchFilters,
  fetchPacsConfiguration,
  fetchPlatformConfigs,
} from "../Modal/Utility";

const CustomNodeHL7Configs = ({ data }) => {
  useEffect(() => {}, []);

  return (
    <div className="custom-node">
      <div className="node-header">HL7 CONFIG</div>

      <div>
        <div className="name">{data?.receive_from}</div>
        <div>{data?.uid}</div>
        {`[${data?.segment_list.join(", ")}]`}
      </div>
      <Handle type="target" position="left" />
      <Handle type="source" position="right" />
    </div>
  );
};

export default CustomNodeHL7Configs;
